import Axios from "axios";
import {backendPathAuth} from "../Constants";



export function loadPermissions(navigate, setReadPermission, setWritePermission) {
    Axios.get(`${backendPathAuth}user-permissions.php?`).then((response) => {
        console.log(response.data);
        if (response.data !== "write" && response.data !== "read") {
            navigate("/login");
        }
        setWritePermission(response.data === "write");
        setReadPermission(response.data === "read" || response.data === "write");
    }).catch(() => { navigate("/login"); });
}


export function checkWritePermission (navigate, setReadPermission, setWritePermission) {
    Axios.get(`${backendPathAuth}user-permissions.php?`).then((response) => {
        console.log(response.data);
        if (response.data !== "write") {
            navigate("/login");
        }
        setReadPermission(response.data === "read" || response.data === "write");
        setWritePermission(response.data === "write");
    }).catch(() => { navigate("/login"); });
}